import {
  getAlertDescription,
  getAlertSeverity,
} from 'features/Weather/features/WeatherAlerts/utils/alertData.utils';
import {
  getAlertSeverityColor,
  getAlertSeverityLabel,
} from 'features/Weather/features/WeatherAlerts/utils/alertSeverity.utils';
import { Polygon } from 'react-leaflet';
import WeatherMapDetailsPopup from '../../../../../../components/WeatherMapDetailsPopup/WeatherMapDetailsPopup';
import {
  severeWeatherAlertDetailGroups,
  severeWeatherAlertDetails,
} from '../../../../config/severeWeatherAlertDetails.config';
import {
  SEVERE_WEATHER_ALERT_PATH_OPTIONS,
  SEVERE_WEATHER_SELECTED_ALERT_PATH_OPTIONS,
} from '../../../../config/severeWeatherAlerts.config';
import {
  getSevereWeatherAlertAreaLabel,
  getSevereWeatherAlertHeadline,
} from '../../../../utils/severeWeatherAlerts.utils';
import SevereWeatherAlertDescription from '../../../SevereWeatherAlertDescription/SevereWeatherAlertDescription';

const SevereWeatherAlertMapLayers = ({ areas = [], selectedAreaId, onSelectArea }) =>
  areas.flatMap((area) => {
    const isSelected = area.id === selectedAreaId;
    const alert = area.primaryAlert;
    const severity = getAlertSeverity(alert);
    const headline = getSevereWeatherAlertHeadline(alert);
    const areaLabel = getSevereWeatherAlertAreaLabel(area);
    const pathOptions = {
      ...(isSelected
        ? SEVERE_WEATHER_SELECTED_ALERT_PATH_OPTIONS
        : SEVERE_WEATHER_ALERT_PATH_OPTIONS),
      fillColor: getAlertSeverityColor(severity),
    };

    return area.polygons.map((polygon, polygonIndex) => (
      <Polygon
        key={`${area.id}:${polygonIndex}`}
        positions={polygon}
        pathOptions={pathOptions}
        title={areaLabel}
        eventHandlers={{ click: () => onSelectArea?.(area) }}
      >
        <WeatherMapDetailsPopup
          eyebrow={areaLabel}
          title={headline}
          status={
            <span className="d-flex align-items-center gap-2 text-dark">
              <span
                aria-hidden="true"
                className="severe-weather-alert-severity-swatch rounded-circle"
                style={{ backgroundColor: getAlertSeverityColor(severity) }}
              />
              {getAlertSeverityLabel(severity)}
            </span>
          }
          statusClassName="border bg-light text-dark"
          meta={`${area.alerts.length} ${area.alerts.length === 1 ? 'alert' : 'alerts'}`}
          selectedItem={alert}
          details={severeWeatherAlertDetails}
          layoutGroups={severeWeatherAlertDetailGroups}
          ariaLabel={`Details for ${headline}`}
        >
          <div className="mt-2 border-top pt-2">
            <SevereWeatherAlertDescription compact description={getAlertDescription(alert)} />
          </div>
        </WeatherMapDetailsPopup>
      </Polygon>
    ));
  });

export default SevereWeatherAlertMapLayers;
